import {Routes} from "@angular/router";
import {MyOrdersComponent} from "./my-orders.component";

export const myOrdersRoutes: Routes = [
  {path: '', component: MyOrdersComponent}
];
